import React from "react";

const SectionHeading = ({ title, description, small }) => (
  <div className="section-heading">
    <h2 className={small ? "small-heading" : ""}>{title}</h2>
    <p>{description}</p>
  </div>
);

export default SectionHeading;



// WEBPACK FOOTER //
// ./src/components/section-heading.js